export const CREDIT_CARD = 'credit card';
export const PROVIDER_APPLE = 'apple';
export const PAYPAL = 'paypal';

// vendors
export const BRAINTREE = 'braintree';
export const STRIPE_GOOGLE = 'stripe_google';
export const STRIPE = 'stripe';
export const STRIPE_APPLE = 'stripe_apple';

// brands
export const VISA = 'visa';
export const MASTERCARD = 'mastercard';
export const AMERICAN_EXPRESS = 'amex';
export const DISCOVER = 'discover';

// prettier-ignore
export const BILLING_AGREEMENT =
	'Home Chef\'s weekly meal service delivers everything you need to prepare home-cooked meals in about 30 minutes. Please enter your credit card and billing zip code below.';
